import Icon from "../icon";

const WIcon = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_1048879_bv619gnkv0l.js"
});

export default WIcon;
